import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
  white-space: nowrap;
  width: auto;
  height: 28px;
  padding-right: 20px;
  overflow-y: hidden;
  overflow-x: auto;
  column-gap: 16px;
  scroll-behavior: smooth;
  cursor: pointer;
  position: relative;
  z-index: 1;

  @media screen and (min-width: 768px) {
    height: 32px;
    column-gap: 32px;
  }
`;

export const Item = styled.div<{
  isActive: boolean;
  inactiveTextColor?: string;
}>`
  display: flex;
  flex-direction: column;
  row-gap: 2px;
  width: auto;

  p {
    text-transform: uppercase;
    font-family: Gilroy;
    font-weight: 700;
    font-size: 16px;
    color: ${({ isActive, inactiveTextColor }) =>
      isActive ? "#00bcf1" : inactiveTextColor || "white"};
  }

  @media screen and (min-width: 768px) {
    p {
      font-size: 20px;
    }
  }
`;

export const Underline = styled.div`
  height: 4px;
  width: 100%;
  background-color: #00bcf1;
  border-radius: 4px;
`;
